const stripTypenameField = <T extends Record<string, unknown>>(item: T) => {
    const { __typename: typename, ...rest } = item;
    return { ...rest } as T;
};

export default stripTypenameField;
